module.exports = __webpack_public_path__ + "static/media/services-icon-3.37a464fb.svg";